export default class PromiseService {
    /**
     * Creates a promise which can be 'ignored', meaning if the ignore is called, this promise will no longer resolve or reject;
     *
     * @param {Promise<T>} promise - a promise
     * @returns {[Promise<T>, () => void ]} - the ignorable promise, and a function to call to ignore the promise
     */
    static createIgnorablePromise(promise) {
        let resolve = null;
        let reject = null;
        const wrappedPromise = new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });
        promise.then((val) => {
            if (resolve) {
                resolve(val);
            }
        }, (error) => {
            if (reject) {
                reject(error);
            }
        });
        return [
            wrappedPromise,
            () => {
                resolve = null;
                reject = null;
            },
        ];
    }
}
